import { memo } from 'react';

/**
 * A convenience function for memoizing a component with a displayName, without
 * requiring the component to be defined as a named function or a separate
 * variable.
 *
 * @param {string} displayName The `displayName` to attach to the given `Component`
 * @param {Function} Component A function component to memoize
 * @param {Function} propsAreEqual An optional function that compares the previous and next props
 */
export function memoWithDisplayName(displayName, Component, propsAreEqual) {
  Component.displayName = displayName;
  return /*#__PURE__*/memo(Component, propsAreEqual);
}